export const COMMON_SWIPER_OPTIONS = {
  SPACE_BETWEEN: 10,
  SLIDES_PER_VIEW: 'auto',
}

export const SLIDES_PER_GROUP = {
  VERTICAL_L: 5,
  HIGHLIGHT: 3,
  HORIZONTAL_S: 5,
  HORIZONTAL_M: 4,
  HORIZONTAL_L: 3,
}
